import AuthActionTypes from './AuthActionTypes'

export interface SetIsLogged {
  type: AuthActionTypes.SET_IS_LOGGED;
  payload: {
    isLogged: boolean
  }
}

export function setIsLogged(isLogged: boolean): SetIsLogged {
  return {
    type: AuthActionTypes.SET_IS_LOGGED,
    payload: {
      isLogged,
    },
  }
}
